import * as moment from 'moment';
import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as shortId from 'shortid';
import TileWall, { TileObject } from '../../components/tileWall/tileWall';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoicesState } from '../../data/invoices/invoicesModels';
import { newsActionCreators } from '../../data/news/newsActions';
import { ApiNewsState } from '../../data/news/newsModels';
import { opportunitiesActionCreators } from '../../data/opportuneties/opportunetisActions';
import { ApiOpportunitiesState } from '../../data/opportuneties/opportunetisModels';
import { orderActionCreators } from '../../data/order/orderActions';
import { ApiOrderState } from '../../data/order/orderModels';
import { projectsActionCreators } from '../../data/projects/projectsAction';
import { ProjectsState } from '../../data/projects/projectsModels';
import { shipmentsActionCreators } from '../../data/shipment/shipmentAction';
import { ShipmentState } from '../../data/shipment/shipmentModels';
import { userActionCreators } from '../../data/user/userActions';
import { UserState } from '../../data/user/userModels';
import tileArr from './hardCodedData';
import './home.css';
// tslint:disable-next-line:no-var-requires
const apple = require('../../resources/apple.png');
// tslint:disable-next-line:no-var-requires
const ductDesign = require('../../resources/duct-design.png');
// tslint:disable-next-line:no-var-requires
const invoices = require('../../resources/invoices.png');
// tslint:disable-next-line:no-var-requires
const news = require('../../resources/news.png');
// tslint:disable-next-line:no-var-requires
const orders = require('../../resources/orders.png');
// tslint:disable-next-line:no-var-requires
const shoppingCart = require('../../resources/shopping-cart.png');
// tslint:disable-next-line:no-var-requires
const USD = require('../../resources/USD.png');
// tslint:disable-next-line:no-var-requires
const shipmentsIcon = require('../../resources/shipments.png');
// tslint:disable-next-line:no-var-requires
const QFV = require('../../resources/3d.png');

interface HomeState {
    opportunities: ApiOpportunitiesState;
    projects: ProjectsState;
    news: ApiNewsState;
    header: HeaderState;
    order: ApiOrderState;
    invoices: ApiInvoicesState;
    user: UserState;
    shipments: ShipmentState;
}

interface HomeActions {
    opportunitiesActions: typeof opportunitiesActionCreators;
    projectActions: typeof projectsActionCreators;
    newsActions: typeof newsActionCreators;
    headerActions: typeof headerActionCreators;
    orderActions: typeof orderActionCreators;
    invoicesActions: typeof invoicesActionCreators;
    userActions: typeof userActionCreators;
    shipmentActions: typeof shipmentsActionCreators;
}

interface TileBodyObject {
    linkName?: string | undefined;
    url?: string | undefined;
    linkTitle?: string | undefined;
    links?: TileBodyObject[] | undefined;
    f?: () => void;
}

type HomeProps = HomeState & // ... state we've requested from the Redux store
    HomeActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

// tslint:disable-next-line:no-empty-interface
interface State {
    //
}

class Home extends React.Component<HomeProps, State> {
    constructor(props: HomeProps) {
        super(props);
        this.createTiles = this.createTiles.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.renderHead = this.renderHead.bind(this);
        this.renderRecentOpportunities = this.renderRecentOpportunities.bind(this);
        this.renderDuctInstallationDesign = this.renderDuctInstallationDesign.bind(this);
        this.renderSubmittedOrders = this.renderSubmittedOrders.bind(this);
        this.renderInvoices = this.renderInvoices.bind(this);
        this.renderInternalNews = this.renderInternalNews.bind(this);
        this.renderRecentNews = this.renderRecentNews.bind(this);
        this.renderResourcesAndTraining = this.renderResourcesAndTraining.bind(this);
        this.renderLoading = this.renderLoading.bind(this);
        this.createErrorMessage = this.createErrorMessage.bind(this);
        this.renderShipments = this.renderShipments.bind(this);
        this.renderBodyMultiLinks = this.renderBodyMultiLinks.bind(this);
    }

    renderLoading() {
        return (
            <div className="centerThis">
                <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
            </div>
        );
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
    }

    componentDidUpdate(prevProps: HomeProps) {
        if (
            this.props.news.thenews !== prevProps.news.thenews ||
            this.props.invoices.invoices !== prevProps.invoices.invoices ||
            this.props.order.orders !== prevProps.order.orders ||
            this.props.projects.projects !== prevProps.projects.projects ||
            this.props.opportunities.opportunities !== prevProps.opportunities.opportunities ||
            this.props.shipments.shipments !== prevProps.shipments.shipments
        ) {
            this.forceUpdate();
        }
    }

    renderQTO() {
        return new TileObject(this.renderHead(tileArr[0].tileHead, shoppingCart), this.renderBody(tileArr[0].tileBody));
    }

    renderQFV() {
        return new TileObject(this.renderHead(tileArr[8].tileHead, QFV), this.renderBody(tileArr[8].tileBody));
    }

    renderRecentOpportunities() {
        let tileBody: JSX.Element;
        if (this.props.opportunities.opportunities.length > 0) {
            const b = this.props.opportunities.opportunities.slice(0, 5);
            const head: TileBodyObject[] = Array<any>();
            b.map((x, index) => {
                head.push({
                    linkName: moment(x.createdDate, 'M/D/YYYY').format('M/D/YYYY') + ', ' + x.company + ', ' + x.topic,
                    f: () => {
                        this.props.history.push('/opportunitie/' + x.opportunityid);
                    }
                });
            });

            tileBody = this.renderBody(head);
        } else {
            if (this.props.opportunities.loading) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead(tileArr[1].tileHead, USD), tileBody, () => {
            this.props.history.push('/opportunities');
        });
    }

    renderDuctInstallationDesign() {
        let tileBody: JSX.Element;
        if (this.props.projects.projects.length > 0) {
            const b = this.props.projects.projects.slice(0, 5);
            const head: TileBodyObject[] = Array<any>();
            b.map((x) => {
                head.push({
                    linkName: x.name,
                    f: () => {
                        this.props.history.push('/ductdesignproject/' + x.projectNumber);
                    }
                });
            });
            tileBody = this.renderBody(head);
        } else {
            if (this.props.projects.loading) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead(tileArr[2].tileHead, ductDesign), tileBody, () => {
            this.props.history.push('/ductdesign');
        });
    }

    renderShipments() {
        let tileBody: JSX.Element;
        if (this.props.shipments.shipments.length > 0) {
            const b = this.props.shipments.shipments.slice(0, 5);
            const head: TileBodyObject[] = Array<any>();
            b.map((x) => {
                head.push({
                    linkName: x.orderNumber + ' (' + x.pONumber + ') ' + x.shipToName,
                    f: () => {
                        this.props.history.push('/shipment/' + x.shipmentId);
                    }
                });
            });
            tileBody = this.renderBody(head);
        } else {
            if (this.props.shipments.loading) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead(tileArr[7].tileHead, shipmentsIcon), tileBody, () => {
            this.props.history.push('/shipments');
        });
    }

    renderSubmittedOrders() {
        let tileBody: JSX.Element;
        if (this.props.order.orders.length > 0) {
            const b = this.props.order.orders.slice(0, 5);
            const head: TileBodyObject[] = Array<any>();
            b.map((x) => {
                head.push({
                    linkName: x.orderNumber + ' (' + x.purchaseOrder + ') ' + x.shippingName,
                    f: () => {
                        this.props.history.push('/order/' + x.orderId);
                    }
                });
            });
            tileBody = this.renderBody(head);
        } else {
            if (this.props.order.loading) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead(tileArr[3].tileHead, orders), tileBody, () => {
            this.props.history.push('/orders');
        });
    }

    renderInvoices() {
        let tileBody: JSX.Element;
        if (this.props.invoices.invoices.length > 0) {
            const b = this.props.invoices.invoices.slice(0, 5);
            const head: TileBodyObject[] = Array<any>();
            b.map((x) => {
                head.push({
                    linkName: x.invoiceNumber + ' (' + x.poNumber + ') ' + x.shiptoname,
                    f: () => {
                        this.props.history.push('/invoice/' + x.invoiceId);
                    }
                });
            });
            tileBody = this.renderBody(head);
        } else {
            if (this.props.invoices.loading) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead(tileArr[4].tileHead, invoices), tileBody, () => {
            this.props.history.push('/invoices');
        });
    }

    renderInternalNews() {
        let tileBody: JSX.Element;
        if (this.props.news.internalnews.length > 0) {
            const b = this.props.news.internalnews.slice(0, 5);
            const head = Array<any>();
            for (const x of b) {
                head.push({
                    linkName: x.topic,
                    f: () => {
                        this.props.history.push('/internalnews');
                    }
                });
            }
            tileBody = this.renderBody(head);
        } else {
            if (this.props.news.loadinginternal) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead('Nordfab Dealer News', news), tileBody, () => {
            this.props.history.push('/internalnews');
        });
    }

    renderRecentNews() {
        let tileBody: JSX.Element;
        if (this.props.news.thenews.length > 0) {
            const b = this.props.news.thenews.slice(0, 5);
            const head = Array<any>();
            for (const x of b) {
                head.push({ linkName: x.topic, url: x.url });
            }
            tileBody = this.renderBody(head);
        } else {
            if (this.props.news.loading) {
                tileBody = this.renderLoading();
            } else {
                tileBody = <div className="topBorder" />;
            }
        }
        return new TileObject(this.renderHead('Recent News', news), tileBody, () => {
            this.props.history.push('/news');
        });
    }

    renderResourcesAndTraining() {
        return new TileObject(this.renderHead(tileArr[6].tileHead, apple), this.renderBody(tileArr[6].tileBody));
    }
    /* tslint:disable */
    renderHead(title: string, logo: any) {
        return (
            <div>
                <div className="float-left">
                    <h4>{title}</h4>
                </div>
                <div className="tileImage float-right">
                    <img src={logo} />
                </div>
            </div>
        );
    }

    renderBody(obj: TileBodyObject[]) {
        let arr: JSX.Element[] = Array<any>();
        for (let x of obj) {
            if (x.links !== undefined && x.linkTitle !== undefined) {
                arr.push(
                    <li key={shortId.generate()}>
                        <span className="tileMultiLink">
                            {x.linkTitle}
                            {this.renderBodyMultiLinks(x.links)}
                        </span>
                    </li>
                );
            } else {
                arr.push(
                    <li className="tileLink" key={shortId.generate()}>
                        <span
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (x.url) {
                                    window.open(x.url);
                                }
                                if (x.f) {
                                    x.f();
                                }
                            }}
                        >
                            {x.linkName}
                        </span>
                    </li>
                );
            }
        }
        return (
            <div>
                <div className="topBorder"></div>
                <ul>{arr}</ul>
            </div>
        );
    }

    renderBodyMultiLinks(links: TileBodyObject[]) {
        let arr: JSX.Element[] = Array<any>();
        links.forEach((link, key) => {
            arr.push(
                <span
                    key={shortId.generate()}
                    className="tileLink"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (link.url) {
                            window.open(link.url);
                        }
                        if (link.f) {
                            link.f();
                        }
                    }}
                >
                    {link.linkName}
                </span>
            );
            if (links.length - 1 != key) {
                arr.push(<span key={shortId.generate()}> | </span>);
            }
        });

        return arr;
    }

    createTiles(props: HomeProps) {
        let arr = Array<any>();
        if (this.props.user.permissions.qfv.read) {
            arr.push(this.renderQFV());
        }
        if (this.props.user.permissions.quickTickOnline.read) {
            arr.push(this.renderQTO());
        }
        if (this.props.user.permissions.opportunities.read) {
            arr.push(this.renderRecentOpportunities());
        }
        if (this.props.user.permissions.duct.read) {
            arr.push(this.renderDuctInstallationDesign());
        }
        if (this.props.user.permissions.orders.read) {
            arr.push(this.renderSubmittedOrders());
        }
        if (this.props.user.permissions.orders.read) {
            arr.push(this.renderShipments());
        }
        if (this.props.user.permissions.invoices.read) {
            arr.push(this.renderInvoices());
        }
        if (this.props.user.permissions.news.read) {
            arr.push(this.renderInternalNews());
            arr.push(this.renderRecentNews());
        }
        if (this.props.user.permissions.resourceTraining.read) {
            arr.push(this.renderResourcesAndTraining());
        }
        return arr;
    }

    createErrorMessage() {
        return (
            <div className="container-fluid">
                <div className="errorMessage"> {this.props.user.errorMessage} </div>
            </div>
        );
    }

    public render() {
        return (
            <div className="container-fluid">
                {this.props.user.error && this.props.user.error === true ? (
                    this.createErrorMessage()
                ) : (
                    <TileWall tileObjects={this.createTiles(this.props)} />
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): HomeState {
    return {
        opportunities: state.opportunities,
        projects: state.projects,
        news: state.news,
        header: state.header,
        order: state.order,
        invoices: state.invoices,
        user: state.user,
        shipments: state.shipments
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): HomeActions {
    return {
        opportunitiesActions: bindActionCreators(opportunitiesActionCreators, dispatch),
        projectActions: bindActionCreators(projectsActionCreators, dispatch),
        newsActions: bindActionCreators(newsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        orderActions: bindActionCreators(orderActionCreators, dispatch),
        invoicesActions: bindActionCreators(invoicesActionCreators, dispatch),
        userActions: bindActionCreators(userActionCreators, dispatch),
        shipmentActions: bindActionCreators(shipmentsActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Home)
);



// WEBPACK FOOTER //
// ./src/containers/home/home.tsx